import request from './base/http';
// 用户登录 信息

export default {
  Login(data) {
    return request({
      method: 'post',
      url: '/Common/Login',
      data,
    });
  },
  UserInfo(data) {
    return request({
      method: 'get',
      url: '/User/UserInfo',
      params: data,
    });
  },
  Exit(data) {
    return request({
      method: 'get',
      url: '/Common/Exit',
      params: data,
    });
  },
};
